import { WidgetPieNumeric } from '../Widgets';
import { connect } from 'react-redux';
import { getSubsDrillData, getSubMethodLookupData } from '../../redux/actions/subs';

const mapStateToProps = (state, ownProps) => ({
  className: ownProps.className,
  width: ownProps.width,
  height: ownProps.height,
  graph: state.subs.drillData && state.filter.filters.startDate  && state.filter.filters.endDate ? state.subs.drillData.filter(item => item._id).map(item => ({
    value: item['ns'],
    key: (state.subs.lookupData && ownProps.filters.param === 'subMethod') ?
          (state.subs.lookupData.filter(i => (i.id === item[ownProps.filters.param])).length !== 0 ? state.subs.lookupData.filter(i => (i.id === item[ownProps.filters.param]))[0].value : '') : item[ownProps.filters.param]
  })) : [],
  infoItems: state.subs.drillData && state.filter.filters.startDate  && state.filter.filters.endDate ? state.subs.drillData.filter(item => item._id).map(item => ({
    amount: item['ns'],
    description: (state.subs.lookupData && ownProps.filters.param === 'subMethod') ?
          (state.subs.lookupData.filter(i => (i.id === item[ownProps.filters.param])).length !== 0 ? state.subs.lookupData.filter(i => (i.id === item[ownProps.filters.param]))[0].value : '') : item[ownProps.filters.param]
  })) : [],
  filters: {
    oc: state.filter.filters.oc,
    srvcId: state.filter.filters.service,
    startDate: state.filter.filters.startDate,
    endDate: state.filter.filters.endDate,
    tz: state.filter.filters.tz,
    ...ownProps.filters
  },
  colorScheme: ownProps.colorScheme,
  title: ownProps.title,
  onZoom: ownProps.onZoom,
  dataLoaded: state.subs.drillLoaded,
  filtersLoaded: state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate
    && ownProps.filters.param
    && ownProps.filters.date,
  loaded: state.subs.drillLoaded
    && state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate
    && ownProps.filters.param
    && ownProps.filters.date,
  close: ownProps.close
})

const mapDispatchToProps = (dispatch) => ({
  fetchData: (params, graphId) => {
    dispatch(getSubsDrillData(params, graphId));
    if(params.param === "subMethod") dispatch(getSubMethodLookupData(params, graphId));
  }
})
export default connect(mapStateToProps, mapDispatchToProps)(WidgetPieNumeric)



// WEBPACK FOOTER //
// ./src/components/ConnectedWidgets/WidgetPieDrillSubsConnected.js